import React, { useState, useEffect } from "react";
import paginationFactory from "react-bootstrap-table2-paginator";
import { useSelector } from "react-redux";
import { SiMicrosoftexcel } from "react-icons/si";
import loadinggif from "../../assets/images/loading.gif";
import filterFactory, {
  textFilter,
  selectFilter,
} from "react-bootstrap-table2-filter";
import BootstrapTable from "react-bootstrap-table-next";
import moment from "moment";
import { FaExclamationTriangle } from "react-icons/fa";
import edMantra from "../../services/edMantra";
// ✅ CSV export utility
const exportToCSV = (data, fileName = "All_Company_Records.csv") => {
  if (!data || !data.length) {
    alert("No data available to export.");
    return;
  }

  const headers = Object.keys(data[0]);
  const csvRows = [
    headers.join(","), // Header row
    ...data.map((row) =>
      headers
        .map(
          (field) => `"${(row[field] ?? "").toString().replace(/"/g, '""')}"`
        )
        .join(",")
    ),
  ];

  const csvContent = csvRows.join("\n");
  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", fileName);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

const ATSReporting = () => {
  const [allVacancy, setAllVacancy] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [allRecruiters, setAllRecruiters] = useState([]);
  const [allCompany, setAllCompany] = useState([]);
  const { data } = useSelector((state) => state?.currentSession?.userInfo);

  // Placeholder: replace with real fetch logic

useEffect(() => {
  const fetchData = async () => {
    try {
      setIsLoading(true);

      const userRole = data?.role?.roleName;
      const empId = data?.empId;

      const queryString =
        userRole === "SuperAdmin" || userRole === "AdminEM"
          ? "limit=100000"
          : `empId=${empId}&limit=100000`;

      const [companyRes, recruiterRes] = await Promise.all([
        edMantra.getAllCompany(queryString),
        edMantra.getAllRecruiters(),
      ]);

      setAllCompany(companyRes.data?.data || []);
      setAllVacancy(companyRes.data?.data || []);
      setAllRecruiters(recruiterRes.data?.data || []);
    } catch (error) {
      console.error("Error fetching ATS data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  fetchData();
}, []);


  const handleRowSelectAll = (isSelected, rows) => {
    setSelectedRows(isSelected ? rows : []);
  };

  const handleRowSelect = (row, isSelected) => {
    if (isSelected) {
      setSelectedRows([...selectedRows, row]);
    } else {
      setSelectedRows(
        selectedRows.filter((r) => r.companyId !== row.companyId)
      );
    }
  };

  const columns = [
    {
      dataField: "companyName",
      text: "Company Name",
      sort: true,
      filter: textFilter(),
      formatter: (cell, row) => {
        const itemObj = allCompany.find(
          (item) => item?.companyId === row?.companyId
        );
        return <p>{itemObj?.companyName || "N/A"}</p>;
      },
    },

    {
      dataField: "primaryPOCName",
      text: "Primary POC Name",
      sort: true,
      filter: textFilter(),
    },
    {
      dataField: "primaryPOCMobile",
      text: "Primary Mobile",
      sort: true,
      filter: textFilter(),
    },
    {
      dataField: "primaryPOCEmail",
      text: "Primary Email",
      sort: true,
      filter: textFilter(),
    },
    {
      dataField: "primaryPOCDesignation",
      text: "Primary POC Designation",
      sort: true,
      filter: textFilter(),
    },
    {
      dataField: "secondaryPOCName",
      text: "Primary POC Name",
      sort: true,
      filter: textFilter(),
    },
    {
      dataField: "secondaryPOCMobile",
      text: "Primary Mobile",
      sort: true,
      filter: textFilter(),
    },
    {
      dataField: "companyStatus",
      text: "Primary Email",
      sort: true,
      filter: textFilter(),
    },
    {
      dataField: "followupDate",
      text: "Primary POC Designation",
      sort: true,
      filter: textFilter(),
    },

    {
      dataField: "orgCategory",
      text: "Org. Category",
      sort: true,
      filter: textFilter(),
    },
    {
      dataField: "orgRate",
      text: "Org. Rate",
      sort: true,
      filter: textFilter(),
    },
    {
      dataField: "orgAgreement",
      text: "Org. Agreement",
      sort: true,
      filter: textFilter(),
    },
    {
      dataField: "createdBy",
      text: "Recruitment Manager",
      filter: selectFilter({
        options:
          allRecruiters.length > 0
            ? allRecruiters.map((emp) => ({
                value: emp.empId,
                label: `${emp.fname} ${emp.lname}`,
              }))
            : [],
        placeholder: "Select or Search by Name",
      }),
      formatter: (cell, row) => {
        const itemObj = allRecruiters.find(
          (emp) => emp.empId === row.createdBy
        );
        return <p>{itemObj ? `${itemObj.fname} ${itemObj.lname}` : "N/A"}</p>;
      },
    },
  ];

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-md-4 card border-0">
          <p className="fs-3 fw-normal typed-text">ATS Reporting</p>
        </div>

        <div className="col-md-4 card border-0">
          {/* Optional: Add dropdowns or filters here */}
        </div>

        <div className="card col-md-12 border-0">
          <button
            className="btn btn-primary btn-sm mb-2 me-2"
            onClick={() => {
              const validData = allVacancy.filter(
                (item) => item && item.companyId
              );
              const flatData = validData.map((row) =>
                columns.reduce((acc, col) => {
                  acc[col.dataField] = row[col.dataField] ?? "";
                  return acc;
                }, {})
              );
              exportToCSV(flatData);
            }}
          >
            <SiMicrosoftexcel /> Export All Company Records
          </button>

          {isLoading ? (
            <div className="d-flex justify-content-center align-items-center">
              <img src={loadinggif} alt="Loading" />
            </div>
          ) : (
            <div className="table-responsive cus-table">
              <style>
                {`
                  @keyframes blink {
                    0% { opacity: 1; }
                    50% { opacity: 0; }
                    100% { opacity: 1; }
                  }
                `}
              </style>
              <BootstrapTable
                keyField="companyId"
                data={allVacancy}
                columns={columns}
                striped
                hover
                condensed
                filter={filterFactory()}
                pagination={paginationFactory({ showTotal: true })}
                selectRow={{
                  mode: "checkbox",
                  clickToSelect: true,
                  onSelect: handleRowSelect,
                  onSelectAll: handleRowSelectAll,
                }}
                filterPosition="top"
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ATSReporting;
